import React from 'react'
import { Loader } from '../Loader'
import * as S from './styled'
import type { Props } from './types'

export const Loading = ({
  isLoading,
  size = 'large',
  variant = 'transparent',
  loaderPosition = 'center',
  children,
}: Props) => {
  return (
    <S.Container $isLoading={isLoading}>
      {children}
      {isLoading && (
        <S.OverlayContainer
          $loaderPosition={loaderPosition}
          $variant={variant}
          data-testid="Loading.Overlay"
        >
          <Loader size={size} />
        </S.OverlayContainer>
      )}
    </S.Container>
  )
}
